import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import {Button} from "@material-ui/core";
import GenericDialog from "../../../../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {useTheme} from "@material-ui/core/styles";

const RiepilogoDialog = (props) => {
    const theme = useTheme()

    const dialogContent = (
        <Typography variant="body2" style={{color: theme.palette.font.light}}>
            Le tue SIM verranno attivate con la seguente configurazione.<br/>
            <b>I valori di default potrebbero comportare costi aggiuntivi.</b> <br/>
            è tuttavia possibile modificare i valori in qualsiasi momento.
        </Typography>
    );

    const dialogActions = (
        <Button onClick={props.handleDialogClose}
                color="primary"
                variant="contained">
            ne ho preso visione
        </Button>
    );

    return (
        <GenericDialog dialogWidth="sm"
                       open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogActions={dialogActions}
                       dialogContent={dialogContent}>
            <Typography variant={"h6"}>
                Riepilogo della tua richiesta di attivazione
            </Typography>
        </GenericDialog>
    )
}

RiepilogoDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired
}


export default RiepilogoDialog